import { HTMLAttributes, useState, useEffect } from "react";
import { CommonInstallflowFrame } from "./common-install-flow-frame";
import SensorInstalledSuccessfullyImage from "@/assets/sensor-installed-successfully.png";
import { useNavigate } from "@tanstack/react-router";
import {
  installFlowSensorKitSerial,
  installFlowAssetName,
  installFlowLocationName,
} from "@/installFlow/storage-keys";

interface AuthProps extends HTMLAttributes<HTMLDivElement> {}
export function SensorInstalledSuccessfully({ className }: AuthProps) {
    const [SerialNumber, setSerialNumber] = useState<string>("");
    const [AssetName, setAssetName] = useState<string>("");
    const [Location, setLocation] = useState<string>("");
    const navigate = useNavigate();
    useEffect(() => {
        if (typeof sessionStorage === "undefined") return;
        const storedSerial = installFlowSensorKitSerial.get();
        const stored = installFlowAssetName.get();
        const storedLocation = installFlowLocationName.get();
        if (storedSerial) setSerialNumber(storedSerial);
        if (stored) setAssetName(stored);
        if (storedLocation) setLocation(storedLocation);
      }, []);

  return (
    <CommonInstallflowFrame>
      <div className="flex flex-col items-center justify-center w-full gap-2 mt-4">
        <img
          src={SensorInstalledSuccessfullyImage}
          alt="sensor installed successfully"
          className="w-36 h-36 pb-6"
        ></img>
        <div className="flex flex-col items-center justify-center w-full max-w-md">
            <h2 className="text-xl font-bold text-black leading-3">Sensor installed successfully</h2>
            <div className="mt-6 w-full rounded-xl border border-gray-200 bg-white shadow-md p-6">
              <div className="flex flex-col gap-2 text-base text-gray-600">
                <span>Sensor: {SerialNumber}</span>
                <span>Asset: {AssetName}</span>
                <span>Location: {Location}</span>
              </div>
              <div className="border-t border-gray-200 mt-4 pt-4">
                <div className="flex flex-col gap-2 text-gray-900">
                  <span>Power: <span className="text-blue-600">On</span></span>
                  <span>Connection: <span className="text-blue-600">Secure</span></span>
                  <span>Data: <span className="text-blue-600">Streaming</span></span>
                </div>
                <button
                  type="button"
                  className="mt-4 w-full rounded-full bg-gray-200 py-3 px-6 text-gray-900 font-medium hover:bg-gray-300 transition-colors"
                  onClick={() => navigate({ to: "/installFlow/live-data" })}
                >
                  Share status
                </button>
              </div>
            </div>
        </div>
      </div>
    </CommonInstallflowFrame>
  );
}
